var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 70,
    viewBox: "0 0 62 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.9217 0L56.2986 62.9927L31.0227 70L5.81634 63.0026L0.199219 0H61.9217Z",
    fill: "#004CE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4828 58.9825L56.2881 5.15234H31.0586V64.6449L51.4828 58.9825Z",
    fill: "#0065F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0791 28.5186L13.7716 36.2455H31.0632L34.3869 32.382L31.0632 28.5186H13.0791ZM31.0632 12.8789H11.6875L12.3899 20.606H31.0632L34.3869 16.7424L31.0632 12.8789ZM31.0632 56.6258L34.3869 52.5282L31.0632 48.5864L31.0293 48.5954L22.4237 46.2718L21.8736 40.1091H14.1169L15.1994 52.2416L31.0276 56.6356L31.0632 56.6258Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5501 36.2455L39.6532 46.2668L31.0352 48.5929V56.6319L46.8759 52.2416L46.9922 50.9362L48.8079 30.5935L48.9965 28.5186L50.3914 12.8789H31.0352V20.606H41.9233L41.2202 28.5186H31.0352V36.2455H40.5501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.ec696fd0164aeb4e68a6570e28ef784c.svg";
export { ForwardRef as ReactComponent };